module.exports = __webpack_public_path__ + "img/homeIntro3.ee9ed794.jpg";